"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LastSavedIndicator = void 0;
const React = __importStar(require("react"));
const time_1 = require("../../../util/time");
const interval_1 = __importDefault(require("../../../hooks/interval"));
const LastSavedIndicator = ({ lastSaved }) => {
    const generateLastSavedMessage = () => `Last saved ${(0, time_1.getLastSavedMessage)(lastSaved)}`;
    const [message, setMessage] = React.useState(generateLastSavedMessage());
    (0, interval_1.default)(() => {
        setMessage(generateLastSavedMessage());
    }, 1000);
    return React.createElement(React.Fragment, null, message);
};
exports.LastSavedIndicator = LastSavedIndicator;
//# sourceMappingURL=LastSavedIndicator.js.map